import { Box } from "@chakra-ui/react";

const CartNavbar = () => {
  return (
    <Box bg="#231535" color="white" position="sticky" top="0px" zIndex="3">
      Crystal & Gold
    </Box>
  );
};

export default CartNavbar;
